"use strict";
import AOS from "aos";
import main from "../css/sass/main.scss";
import inline from "../css/sass/inline.scss";

import inputSelect from "./scripts/inputSelect";
import headerScrolling from "./scripts/headerScrolling";
import mobileMenu from "./scripts/mobileMenu";
import inputFilter from "./scripts/inputFilter";
import setupExpeditionFilters from "./scripts/homeProdSlider";
import homeDiferenciaisSlider from "./scripts/homeDiferenciaisSlider";
import homeTestimonialsSlider from "./scripts/homeTestimonialsSlider";
import homeProductSlider from "./scripts/homeProductSlider";
import homeblogSlider from "./scripts/homeblogSlider";
import blogFeatured from "./scripts/blogFeatured";
import expeditionFilter from "./scripts/expeditionFilter";
import blogFilter from "./scripts/blogFilter";
import blogSearch from "./scripts/blogSearch";
import galeriaSlider from "./scripts/galeriaSlider";
import pacoteSlider from "./scripts/pacoteSlider";
import singleExpedicoes from "./scripts/singleExpedicoes";
import accordion from "./scripts/accordion";
import setupShopArchive from "./scripts/shopFilter";
import setupViagemFilter from "./scripts/viagemFilter";

AOS.init({
    once: true,
});

inputSelect();
headerScrolling();
mobileMenu();
inputFilter();
setupExpeditionFilters();
homeDiferenciaisSlider();
homeTestimonialsSlider();
homeProductSlider();
homeblogSlider();
blogFeatured();
expeditionFilter();
blogFilter();
blogSearch();
galeriaSlider();
pacoteSlider();
singleExpedicoes();
accordion();
setupShopArchive();
setupViagemFilter();

document.querySelector(".get-to_top")?.addEventListener("click", () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
});
